module.exports = __webpack_public_path__ + "img/ic_invoices.4252f084.svg";